<div class="wrap">
  <div class="card">
  <div class="card-header">
    <div class="title">
      <img src="assets/IconORA.svg" alt="" class="ico" />
      <h1>{{ 'profile-ia.header.title' | translate }}</h1>
    </div>
    <div class="action-buttons" *ngIf="selectedQueue()?.config">
      <button type="button" class="secondary" *ngIf="hasChanges()" (click)="cancelChanges()">
        {{ 'profile-ia.actions.cancel' | translate }}
      </button>
      <button type="button" class="primary" (click)="saveConfig()" [disabled]="saving()">
        {{ (saving() ? 'profile-ia.actions.saving' : 'profile-ia.actions.save') | translate }}
      </button>
    </div>
  </div>

  <div class="card-body" *ngIf="!loading(); else loadingTpl">
    <div *ngIf="configs().length === 0 || !selectedQueue()?.config" class="wizard-invitation">
      <img src="assets/IconORA.svg" alt="" class="wizard-icon" />
      <h3>{{ 'profile-ia.wizardInvitation.title' | translate }}</h3>
      <p>{{ 'profile-ia.wizardInvitation.body' | translate }}</p>
      <p class="encouragement">{{ 'profile-ia.wizardInvitation.encouragement' | translate }}</p>
      <button type="button" class="wizard-btn" (click)="openWizard()">
        <img src="assets/IconORA.svg" alt="" class="btn-icon" />
        {{ 'profile-ia.wizardInvitation.launch' | translate }}
      </button>
    </div>

    <div *ngIf="selectedQueue()?.config" class="config-sections">
      <!-- Colonne 1 -->
      <div class="section">
        <h4>{{ 'profile-ia.demandDays.sectionTitle' | translate }}</h4>

        <label>{{ 'profile-ia.demandDays.lowDaysLabel' | translate }}</label>
        <div class="days-chips">
          <button type="button" *ngFor="let day of days"
                  class="chip-toggle"
                  [class.active]="isLowDay(day)"
                  (click)="toggleLowDay(day)">
            {{ getDayLabel(day) }}
          </button>
        </div>

        <label>{{ 'profile-ia.demandDays.normalDaysLabel' | translate }}</label>
        <div class="days-chips">
          <button type="button" *ngFor="let day of days"
                  class="chip-toggle"
                  [class.active]="isNormalDay(day)"
                  (click)="toggleNormalDay(day)">
            {{ getDayLabel(day) }}
          </button>
        </div>

        <label>{{ 'profile-ia.demandDays.highDaysLabel' | translate }}</label>
        <div class="days-chips">
          <button type="button" *ngFor="let day of days"
                  class="chip-toggle"
                  [class.active]="isHighDay(day)"
                  (click)="toggleHighDay(day)">
            {{ getDayLabel(day) }}
          </button>
        </div>

        <label>{{ 'profile-ia.demandDays.avgWeekdayLabel' | translate }}</label>
        <input type="number" [value]="selectedQueue()?.config?.data?.demand?.avg_weekday || 0"
               (input)="updateDemandField('avg_weekday', +$any($event.target).value)">

        <label>{{ 'profile-ia.demandDays.avgWeekendLabel' | translate }}</label>
        <input type="number" [value]="selectedQueue()?.config?.data?.demand?.avg_weekend || 0"
               (input)="updateDemandField('avg_weekend', +$any($event.target).value)">
      </div>

      <!-- Colonne 2 -->
      <div class="section">
        <h4>{{ 'profile-ia.demandActivity.sectionTitle' | translate }}</h4>

        <label>{{ 'profile-ia.demandActivity.appointmentsLabel' | translate }}</label>
        <div class="input-suffix">
          <input type="number" min="0" max="100" step="1" [value]="getShareAppointmentsPct()"
                 (input)="updateShareAppointmentsPct(+$any($event.target).value)">
          <span>%</span>
        </div>

        <label>{{ 'profile-ia.demandActivity.emergenciesLabel' | translate }}</label>
        <input type="number" [value]="selectedQueue()?.config?.data?.demand?.emergencies_per_day || 0"
               (input)="updateDemandField('emergencies_per_day', +$any($event.target).value)">

        <label>{{ 'profile-ia.demandActivity.peakWindowsLabel' | translate }}</label>
        <div class="peak-windows">
          <div *ngFor="let window of getPeakWindows(); let i = index" class="peak-window">
            <input type="time" [value]="window[0]"
                   (input)="updatePeakWindow(i, 0, $any($event.target).value)"
                   class="time-input">
            <span>{{ 'profile-ia.demandActivity.to' | translate }}</span>
            <input type="time" [value]="window[1]"
                   (input)="updatePeakWindow(i, 1, $any($event.target).value)"
                   class="time-input">
            <button type="button" class="btn-remove" (click)="removePeakWindow(i)">×</button>
          </div>
          <button type="button" class="btn-add" (click)="addPeakWindow()">+ {{ 'profile-ia.demandActivity.add' | translate }}</button>
        </div>

        <label>{{ 'profile-ia.demandActivity.difficultCasesLabel' | translate }}</label>
        <div class="input-suffix">
          <input type="number" min="0" max="100" step="1" [value]="getDifficultCasesPct()"
                 (input)="updateDifficultCasesPct(+$any($event.target).value)">
          <span>%</span>
        </div>
      </div>

      <!-- Colonne 3 -->
      <div class="section">
        <h4>{{ 'profile-ia.service.sectionTitle' | translate }}</h4>

        <label>{{ 'profile-ia.service.roomsLabel' | translate }}</label>
        <input type="number" min="1" [value]="selectedQueue()?.config?.data?.service?.rooms || 0"
               (input)="updateServiceField('rooms', +$any($event.target).value)">

        <label>{{ 'profile-ia.service.simpleDurationLabel' | translate }}</label>
        <div class="input-suffix">
          <input type="number" min="1" [value]="selectedQueue()?.config?.data?.service?.simple_min || 0"
                 (input)="updateServiceField('simple_min', +$any($event.target).value)">
          <span>min</span>
        </div>

        <label>{{ 'profile-ia.service.complexDurationLabel' | translate }}</label>
        <div class="input-suffix">
          <input type="number" min="2" [value]="selectedQueue()?.config?.data?.service?.complex_min || 0"
                 (input)="updateServiceField('complex_min', +$any($event.target).value)">
          <span>min</span>
        </div>

        <label>{{ 'profile-ia.service.staffPerDayLabel' | translate }}</label>
        <input type="number" min="1" [value]="selectedQueue()?.config?.data?.service?.staff_per_slot?.default || 0"
               (input)="updateStaffPerSlotDefault(+$any($event.target).value)">

        <label>{{ 'profile-ia.service.peakStaffLabel' | translate }}</label>
        <div class="peak-staff">
          <div *ngFor="let window of getPeakWindows(); let i = index" class="peak-staff-item">
            <span class="time-range">{{ window[0] }} → {{ window[1] }}</span>
            <div class="input-suffix">
              <input type="number" min="1" [value]="getPeakStaffForWindow(window)"
                     (input)="updatePeakStaffForWindow(window, +$any($event.target).value)"
                     class="staff-input">
              <span>{{ 'profile-ia.service.staffUnit' | translate }}</span>
            </div>
          </div>
          <div *ngIf="getPeakWindows().length === 0" class="no-peaks">
            {{ 'profile-ia.service.noPeaks' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loadingTpl>
    <div class="loading">{{ 'profile-ia.loading' | translate }}</div>
  </ng-template>

  </div>
</div>

<!-- Popup de confirmation -->
<div *ngIf="showConfirmModal()" class="modal-overlay" (click)="cancelSave()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <h3>{{ 'profile-ia.confirmModal.title' | translate }}</h3>
    <p>{{ 'profile-ia.confirmModal.body' | translate }}</p>
    <div class="modal-actions">
      <button type="button" class="secondary" (click)="cancelSave()">{{ 'profile-ia.actions.cancel' | translate }}</button>
      <button type="button" class="primary" (click)="confirmSave()" [disabled]="saving()">
        {{ (saving() ? 'profile-ia.actions.saving' : 'profile-ia.actions.confirm') | translate }}
      </button>
    </div>
  </div>
</div>